export interface ViewportState {
	width: number
}

export enum VIEWPORT_STATE_ACTION_TYPES {
	SET_VIEWPORT_WIDTH = 'SET_VIEWPORT_WIDTH',
}

export interface ViewportSetWidthAction {
	type: VIEWPORT_STATE_ACTION_TYPES.SET_VIEWPORT_WIDTH
	payload: number
}

export type ViewportActions = ViewportSetWidthAction
